jQuery(function ($) {
    if ($('.module-layotterstickyteaser').length > 0) {
        const distanceToTop = 80;
        const stickyTeaser = $($('.module-layotterstickyteaser')[0]);
        const gapString = stickyTeaser.attr('data-gap') + 'px';
        const gapInt = parseInt(stickyTeaser.attr('data-gap'));
        const stickyPosition = stickyTeaser.offset().top - distanceToTop + gapInt;
        const footer = $('footer');
        const stickyScrollMax = footer.offset().top - parseInt(footer.css('margin-top').replace('px', '')) - parseInt(footer.css('padding-top').replace('px', '')) - stickyTeaser.outerHeight() - distanceToTop;

        stickyTeaserScroll();

        $(window).on('scroll', function() {
            stickyTeaserScroll();
        }); 

        function stickyTeaserScroll() {
            if ($(window).width() >= 992) {
                const windowScrollTop = $(window).scrollTop();
                if (windowScrollTop > stickyPosition && windowScrollTop <= stickyScrollMax) {
                    stickyTeaser.css('top', (windowScrollTop - stickyPosition + gapInt));
                } else if (windowScrollTop < stickyPosition) {
                    stickyTeaser.css('top', gapString);
                }
            } else {
                stickyTeaser.css('top', 0);
            }
        };
    }
});